import { TWO_CURRENCY_UI } from "@/config/featureFlags";
import CashBalanceChip from "@/components/CashBalanceChip";
import XpChip from "@/components/wallet/XpChip";
import CashCreditsChip from "@/components/wallet/CashCreditsChip";

/**
 * Flag-gated wallet chip wrapper.
 * When TWO_CURRENCY_UI is off (main / live site), renders the original
 * single Approach Points chip unchanged. When on, renders the XP chip and
 * (if non-zero) the Cash Credits chip side-by-side.
 */
const WalletChips = () => {
  if (!TWO_CURRENCY_UI) {
    return <CashBalanceChip />;
  }
  return (
    <div className="flex items-center gap-3">
      <XpChip />
      <CashCreditsChip />
    </div>
  );
};

export default WalletChips;